import React, { useState, useEffect } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { FaFileInvoiceDollar } from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const CreateInvoice = () => {
  const [poData, setPoData] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [paidDate, setPaidDate] = useState(new Date().toISOString().split("T")[0]);
  const [poList, setPoList] = useState([]);
  const fetchPOList = async () => {
    try {
      const token = localStorage.getItem("token");
  
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order?status=approved`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const result = await response.json();
      setPoList(result.data);
    } catch (error) {
      console.error("Error fetching PO list:", error);
    }
  };
  // Fetch detail PO by po_number
  const fetchPOData = async (poNumber) => {
    try {
      const token = localStorage.getItem("token");
      const encodedPoNumber = encodeURIComponent(poNumber);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order/${encodedPoNumber}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch PO data. Status: ${response.status}`);
      }

      const result = await response.json();
      setPoData(result.data);
    } catch (error) {
      console.error("Error fetching PO data:", error);
    }
  };
  useEffect(() => {
    fetchPOList();
  }, []);
  const formatRupiah = (value) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(value);
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      const payload = {
        id_po: poData?.id || 0,
        number: invoiceNumber,
        amount: Number(amount),
        description: description || `Pembayaran ${poData?.number} #1`,
        due_date: dueDate,
        paid_date: paidDate,
      };
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/invoice`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to submit invoice. Status: ${response.status}`);
      }

      const result = await response.json();
      alert("Invoice berhasil disimpan!");
      console.log("Invoice response:", result);
    } catch (error) {
      console.error("Error saving invoice:", error);
      alert("Gagal menyimpan invoice.");
    }
  };

  if (!poList.length) return <p>Loading...</p>;

  const {
    po_number: number = "-",
    status = "-",
    distributor = {},
    outlet = {},
    items = [],
    total_amount = 0,
    created_at = null,
  } = poData || {};
    return (
    <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0 p-5">
      <PageCreateHeader
        icon={FaFileInvoiceDollar}
        title="Buat Invoice"
        description="Buat invoice dari purchase order yang disetujui"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Invoice", to: "/inventory/invoice" },
          { label: "Buat Invoice" },
        ]}
      />

    <div className="p-8 bg-white shadow-lg rounded-lg border border-gray-100 w-full">
    <div className="grid grid-cols-1 gap-8 w-full">
      {/* Kolom Kiri */}
      <div>
        {/* Header */}
        <div className="border-b pb-4 mb-6">
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Pilih Nomor PO</label>
          <select
                onChange={(e) => fetchPOData(e.target.value)}
                className="w-full p-2 border rounded-lg"
              >
                <option value="" disabled>Pilih PO</option>
                {poList.map((po) => (
                  <option key={po.id} value={po.po_number}>
                    {po.po_number} - {po.status}
                  </option>
                ))}
              </select>
        </div>
        <p className="text-sm text-gray-500">
            Dibuat <span className="text-red-500">{poData?.created_at ? new Date(poData.created_at).toLocaleString() : "-"}</span>
          </p>

        </div>
        {/* Detail Pembuat & Tujuan */}
        <div className="grid grid-cols-1 gap-6 mb-6">
          <div>
          <h2 className="text-lg font-semibold">Dari</h2>
              <p className="text-gray-600">{distributor.name}</p>
              <p className="text-gray-500">{distributor.address}</p>
              <p className="text-gray-500">{distributor.phone}, {distributor.email}</p>
          </div>
          <div>
          <h2 className="text-lg font-semibold">Tujuan</h2>
              <p className="text-gray-600">{outlet.name}</p>
              <p className="text-gray-500">{outlet.address}</p>
              <p className="text-gray-500">{outlet.phone}, {outlet.email}</p>
          </div>
        </div>
        {/* Produk */}
        <h2 className="text-lg font-semibold mb-2">Produk</h2>
        <table className="w-full min-w-0 text-left border-collapse mb-6 table-auto">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-4 py-2">No</th>
                <th className="border px-4 py-2">Nama Produk</th>
                <th className="border px-4 py-2">Harga</th>
                <th className="border px-4 py-2">Kuantitas</th>
                <th className="border px-4 py-2">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2 text-center">{index + 1}</td>
                  <td className="border px-4 py-2">{item.obat?.name || "-"}</td>
                  <td className="border px-4 py-2">{formatRupiah(item.price)}</td>
                  <td className="border px-4 py-2 text-center">{item.qty}</td>
                  <td className="border px-4 py-2">{formatRupiah(item.subtotal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        <div className="mb-6">
          <h2 className="text-lg font-semibold">Deskripsi</h2>
          <p className="text-gray-600">{description}</p>
        </div>
        <p className="flex justify-between text-gray-700">
            <span>Untaxed Total</span>
            <span>Rp 3.000.000</span>
          </p>
          <p className="flex justify-between text-gray-700">
            <span>Taxes</span>
            <span>Rp 10.000</span>
          </p>
          <p className="flex justify-between font-bold text-lg mt-2">
            <span>Total</span>
            <span>{formatRupiah(total_amount)}</span>
          </p>
      </div>
      <div>
     {/* Form Invoice */}
<div className="bg-gray-100 p-6 rounded-lg shadow-md w-full">
  <h2 className="text-lg font-semibold mb-4">Previous Invoice</h2>
  <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">No Invoice dari Distributor</label>
            <input
              type="text"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
              className="w-full p-2 border rounded-lg"
              placeholder="Masukkan No Invoice"
            />
          </div>
  <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Amount</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full p-2 border rounded-lg"
              placeholder="Masukkan jumlah (Rp)"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Deskripsi</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border rounded-lg"
              placeholder="Tambahkan deskripsi"
            />
          </div>
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Due Date</label>
    <input
      type="date"
      value={dueDate}
      onChange={(e) => setDueDate(e.target.value)}
      className="w-full p-2 border rounded-lg"
    />
  </div>

  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Paid Date</label>
    <input
      type="date"
      value={paidDate}
      onChange={(e) => setPaidDate(e.target.value)}
      className="w-full p-2 border rounded-lg"
    />
  </div>
  <p className="flex justify-between text-gray-700">
          Estimasi yang harus dibayar <span>Rp 1</span>
        </p>
        <p className="flex justify-between text-gray-700">
          Sisa Amount yang harus dibayar <span>Rp 1</span>
        </p>
  <div className="flex justify-end mt-6">
    <button
      className="bg-green-600 text-white px-6 py-2 rounded-lg flex items-center gap-2"
      onClick={handleSave}
    >
      <CheckIcon className="w-5 h-5" />
      Simpan
    </button>
  </div>
</div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default CreateInvoice;
